export default __webpack_public_path__ + "static/media/_IMG0594.bae1fbab.jpg";